import { IWorkflowProduct } from 'interfaces/runOrchestration/workflowRow';
import style from './CreateProductParams.module.scss'; // do not remove this line
import { parameters } from './consts';
import { ICreateProductParametersProperties } from './types';
import { useCreateProductParameters } from './useCreateProductParameters';
import FormField from './FormField/FormField';

export default function CreateProductParams({
  register,
  setError,
  clearErrors,
  setValue,
  errors,
}: ICreateProductParametersProperties) {
  const { handleFieldChange, modalName, selectedOrchestration } =
    useCreateProductParameters({ clearErrors, errors, setError, setValue });

  return (
    <div data-testid="CreateProductParams">
      {parameters.map((parameter) => (
        <FormField
          key={parameter.paramId}
          param={parameter}
          register={register}
          setError={setError}
          clearErrors={clearErrors}
          modalName={modalName}
          selectedOrchestration={
            selectedOrchestration as IWorkflowProduct | null
          }
          onFieldChange={handleFieldChange}
        />
      ))}
    </div>
  );
}
